<template>
    <b-modal id="unit_status" ref="unit_status" @hidden="resetModal"
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            <div>
                Update Status for<br>
                <div class="text-primary"> {{ unit.data.attributes.name }}</div>
            </div>
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-power-2 mr-3 menu-icon-style"/>

            <p class="my-auto">You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the unit!
            </p>
        </div>

        <b-form>
            <b-row v-if="validationError" class="mb-2">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx xxs="12" class="mt-1 mb-2">
                    <span>Do you want to change the status? <sup><code>*</code></sup></span>
                </b-colxx>

                <b-colxx xxs="2" class="mb-2">
                    <toggle-button v-model="form.active" @input="'active' in errors ? (delete errors.active) : ''"
                                   :labels="{checked: 'YES', unchecked: 'NO'}" :height="28" :width="58"
                                   :color="{checked: '#28A745', unchecked: '#8F8F8F'}"/>
                </b-colxx>

                <b-colxx xxs="10" class="mb-2">
                    <h6>
                        <b-badge :variant="'outline-' + (form.active ? 'success' : 'danger')">
                            The Unit will be {{ form.active ? 'ACTIVE' : 'INACTIVE' }} after submission!
                        </b-badge>
                    </h6>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('unit_status')" v-text="'Cancel'"/>

            <template v-if="currentStatus === form.active">
                <b-button variant="primary" disabled v-text="'Submit'"/>
            </template>

            <template v-else>
                <state-button variant="primary" :click="submitUnitStatus">Submit</state-button>
            </template>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import Switches from 'vue-switches';
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "UnitStatusModal",

        components: {
            Switches,
            StateButton
        },

        data() {
            return {
                validationError: null
            }
        },

        props: [
            'unit', 'currentStatus'
        ],

        computed: {
            ...mapGetters({
                form: 'getUnitStatusForm',
                errors: 'getUnitErrors',
            }),
        },

        methods: {
            submitUnitStatus() {
                let payload = {
                    unit_id: this.unit.unit_id,
                    form: {
                        ...this.form,
                    },
                };

                return new Promise((success, fail) => {
                    this.$store.dispatch('submitUnitStatus', payload)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                let newStatus = response.data.data.attributes.active.toLowerCase() === 'active';

                                this.$emit('updated', newStatus);

                                this.resetModal();

                                this.$notify('success filled', 'Success!', 'Status updated!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('unit_status');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                });
            },

            resetModal() {
                this.$store.commit('setUnitStatusForm');
                this.validationError = null;
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
